import { LinkTag } from '@thd-nucleus/thd-helmet';
import { HD_URL, PAGE_TYPE } from '../constants';

const getStoreDetailsTitle = ({ titlePrefix, storeName, city, postalCode }) => {
  if (storeName && city && postalCode) {
    return `${titlePrefix} Near You at The Home Depot in ${storeName}, ${city}, ${postalCode}`;
  }

  return 'The Home Depot';
};

const getCurrentPromoImageSrc = (emtContentPromotions, pageName) => {
  const promotions = emtContentPromotions || {};
  const today = new Date();
  const currentPromo = Object.values(promotions).find((promo) => {
    const { starts, expires, pageExemptions } = promo || {};
    if (!starts || !expires) {
      return false;
    }
    return new Date(starts) <= today && today < new Date(expires) && !pageExemptions?.includes(pageName);
  });

  return currentPromo?.image?.source;
};

const getPreloadImageTag = (imageURL) => {
  return new LinkTag({
    rel: 'preload',
    href: imageURL,
    id: 'preloadImg',
    as: 'image',
    media: '(max-width: 600px)',
    fetchpriority: 'high'
  });
};

const getStoreDetails = ({ data, path }) => {
  const { name, storeDetailsPageLink, storeServicesPhone } = data?.storeSearch?.stores?.[0] || {};
  const { city, state, postalCode } = data?.storeSearch?.stores?.[0]?.address || {};
  const canonicalURL = `${HD_URL}${storeDetailsPageLink}${path}`;

  return {
    storeName: name,
    city,
    state,
    postalCode,
    storeServicesPhone,
    canonicalURL
  };
};

const getGraphQlReviewsOptions = ({ pageType, page = '', pageSize = 10, storeId }) => {
  const OPTIONS = {
    filters: {
      ageRange: null,
      gender: null,
      isVerifiedPurchase: false,
      profile: null,
      prosCons: null,
      starRatings: null,
    },
    pagesize: pageSize.toString(),
    recfirstpage: pageSize.toString(),
    startIndex: 1,
    sortBy: 'photoreview',
    storeId
  };

  if (pageType === PAGE_TYPE.REVIEWS) {
    let startIndex = Math.max(((page || 1) - 1) * pageSize, 1);
    startIndex = page > 1 ? startIndex + 1 : startIndex;
    OPTIONS.startIndex = startIndex;
  }

  return {
    variables: {
      ...OPTIONS
    }
  };
};

export {
  getCurrentPromoImageSrc,
  getStoreDetailsTitle,
  getStoreDetails,
  getGraphQlReviewsOptions,
  getPreloadImageTag
};